module.exports = __webpack_public_path__ + "img/d1.4666fcd1.png";